const state = {
  products: [
    {
      id: 1,
      name: '智能小镇管理系统',
      category: '智慧城市',
      description: '基于大数据和物联网技术的智慧城市解决方案，实现城市管理的智能化和精细化',
      features: ['实时监控', '数据分析', '智能预警', '移动管理'],
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800',
      price: '定制报价',
      tags: ['智慧城市', '物联网', '大数据']
    },
    {
      id: 2,
      name: '大数据管理系统',
      category: '数据平台',
      description: '企业级大数据处理和分析平台，支持海量数据存储、实时处理和智能分析',
      features: ['数据采集', '实时处理', '智能分析', '可视化展示'],
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800',
      price: '定制报价',
      tags: ['大数据', '云计算', '人工智能']
    }
  ],
  currentProduct: null
}

const mutations = {
  SET_CURRENT_PRODUCT(state, product) {
    state.currentProduct = product
  }
}

const actions = {
  setCurrentProduct({ commit }, product) {
    commit('SET_CURRENT_PRODUCT', product)
  }
}

const getters = {
  getProductById: (state) => (id) => {
    return state.products.find(product => product.id === parseInt(id))
  },
  getProductsByCategory: (state) => (category) => {
    return state.products.filter(product => product.category === category)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}